// extracted by mini-css-extract-plugin
export default {"moiNotFound":"moiNotFound__i1dqq","title":"title__o+Ykv","moiBtn":"moiBtn__H+Nqz"};